import { createFileRoute, redirect } from "@tanstack/react-router"

/** Bookmarks to the old team route land in settings. */
export const Route = createFileRoute("/recruit/team")({
  beforeLoad: () => {
    throw redirect({ to: "/recruit/settings/team" })
  },
  component: () => null,
})
